import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import styled from 'styled-components';
import styles from './ReCaptcha.style';
import constants, { linkTargetWindow } from './../../../constants/globalConstants';
import Para from '../../atoms/Para';
import Anchor from '../../atoms/Anchor';
var isReady = function isReady() {
  return typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.execute !== 'undefined';
};
var readyCheck;
var ReCaptcha = /*#__PURE__*/function (_Component) {
  _inherits(ReCaptcha, _Component);
  var _super = _createSuper(ReCaptcha);
  function ReCaptcha(props) {
    var _this;
    _classCallCheck(this, ReCaptcha);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "loadReCaptcha", function (siteKey) {
      var script = document.createElement('script');
      script.src = constants.API.recaptcha.url + siteKey;
      document.body.appendChild(script);
    });
    _this.execute = _this.execute.bind(_assertThisInitialized(_this));
    _this.state = {
      ready: isReady(),
      tokenLoaded: false
    };
    if (!_this.state.ready) {
      readyCheck = setInterval(_this._updateReadyState.bind(_assertThisInitialized(_this)), 1000);
    }
    return _this;
  }
  _createClass(ReCaptcha, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!isReady()) {
        this.loadReCaptcha(this.props.siteKey);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (this.state.ready && !prevState.ready) {
        this.execute();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(readyCheck);
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;
      var _this$props = this.props,
        saveToken = _this$props.saveToken,
        siteKey = _this$props.siteKey,
        action = _this$props.action;
      if (this.state.ready) {
        try {
          window.grecaptcha.execute(siteKey, {
            action: action
          }).then(function (token) {
            if (typeof saveToken !== 'undefined') {
              saveToken(token);
              _this2.setState({
                tokenLoaded: true
              });
            }
          });
        } catch (err) {
          //Error
        }
      }
    }
  }, {
    key: "_updateReadyState",
    value: function _updateReadyState() {
      if (isReady()) {
        this.setState(function () {
          return {
            ready: true
          };
        });
        clearInterval(readyCheck);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.tokenLoaded ? __jsx(Para, {
        className: "nva-captcha__message recaptcha-message ".concat(this.props.className)
      }, "This site is protected by reCAPTCHA and the Google ", __jsx(Anchor, {
        title: "Privacy Policy",
        className: "nva-captcha__privacy-link capthchaLink",
        "aria-label": "Google reCaptcha Privacy Policy",
        to: "https://policies.google.com/privacy",
        ctaBehavior: linkTargetWindow.newWindow
      }, "Privacy Policy"), " and ", __jsx(Anchor, {
        title: "Terms of Service",
        className: "nva-captcha__terms-link capthchaLink",
        "aria-label": "Google reCaptcha Terms",
        to: "https://policies.google.com/terms",
        ctaBehavior: linkTargetWindow.newWindow
      }, "Terms of Service"), " apply.") : null;
    }
  }]);
  return ReCaptcha;
}(Component);
ReCaptcha.defaultProps = {
  className: '',
  action: '',
  siteKey: ''
};
export default styled(ReCaptcha).withConfig({
  componentId: "sc-167b17k-0"
})(["", ";"], styles);